/**
 * Set when retailer dismisses the POS bulk editor education modal
 */ export var POS_BULK_EDITOR_EDUCATION_MODAL_SEEN = 'POS_BULK_EDITOR_EDUCATION_MODAL_SEEN';
